import { Children, useCallback, useRef } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { jsx as _jsx } from "react/jsx-runtime";
function TransitionChild({
  classNames,
  timeout,
  appear,
  enter,
  exit,
  in: inProp,
  onExited,
  children
}) {
  const nodeRef = useRef(null);
  const wrapperRef = useCallback(el => {
    var _ref;
    nodeRef.current = (_ref = el === null || el === void 0 ? void 0 : el.firstElementChild) !== null && _ref !== void 0 ? _ref : null;
  }, []);
  return /*#__PURE__*/_jsx(CSSTransition, {
    nodeRef: nodeRef,
    classNames: classNames,
    timeout: timeout,
    appear: appear,
    enter: enter,
    exit: exit,
    in: inProp,
    onExited: onExited,
    children: /*#__PURE__*/_jsx("div", {
      ref: wrapperRef,
      style: {
        display: 'contents'
      },
      children: children
    })
  });
}
const CSSTransitionGroupCompat = ({
  transitionName,
  transitionEnterTimeout,
  transitionLeaveTimeout,
  transitionAppearTimeout,
  transitionAppear,
  transitionEnter,
  transitionLeave,
  component,
  children
}) => {
  const timeout = {
    enter: transitionEnterTimeout,
    exit: transitionLeaveTimeout,
    appear: transitionAppearTimeout
  };
  return /*#__PURE__*/_jsx(TransitionGroup, {
    component: component,
    children: Children.toArray(children).filter(Boolean).map(child => /*#__PURE__*/_jsx(TransitionChild, {
      classNames: transitionName,
      timeout: timeout,
      appear: transitionAppear,
      enter: transitionEnter,
      exit: transitionLeave,
      children: child
    }, child.key))
  });
};
export { CSSTransitionGroupCompat as CSSTransitionGroup };